// hooks/useThemes.js - VERSIONE AXIOS
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useThemes = () => {
    console.log('🔍 useThemes chiamato!');
    const [themes, setThemes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const fetchThemes = async () => {
            try {
                setLoading(true);
                setError(null);
                
                //console.log('🎨 Fetching themes...');
                
                const response = await axios.get('/api/themes', {
                    cancelToken: source.token
                });
                
                //console.log('✅ Themes response:', response.data.success ? `${response.data.data?.length || 0} themes` : 'Failed');
                
                if (response.data.success && Array.isArray(response.data.data)) {
                    setThemes(response.data.data);
                } else {
                    setThemes([]);
                    if (response.data.message) {
                        console.warn('⚠️ No themes data:', response.data.message);
                    }
                }
                
            } catch (err) {
                // Ignora errori di cancellazione
                if (!axios.isCancel(err)) {
                    console.error('❌ Error fetching themes:', err.message);
                    setError(err.message);
                    setThemes([]);
                }
            } finally {
                setLoading(false);
            }
        };
        
        fetchThemes();
        
        // Cleanup function
        return () => source.cancel('Component unmounted');
    }, []);
    
    return { 
        themes, 
        loading, 
        error 
    };
};
